var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content open-price" }, [
    _c(
      "div",
      { staticClass: "details-view", staticStyle: { overflow: "auto" } },
      [
        _c(
          "div",
          { staticStyle: { "margin-top": "5px" } },
          [
            _vm.isEdit
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_OpenPrice_edit"],
                        expression: "['button_OpenPrice_edit']"
                      }
                    ],
                    attrs: { no: "Cancel" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                )
              : _vm._e(),
            _vm.isEdit
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_OpenPrice_edit"],
                        expression: "['button_OpenPrice_edit']"
                      }
                    ],
                    attrs: { type: "success", no: "Save" },
                    on: { click: _vm.save }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                )
              : _vm._e()
          ],
          1
        ),
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            {
              staticClass: "section",
              staticStyle: { "margin-top": "5px", width: "100%" }
            },
            [
              _c("div", [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FilingBatchInfo")))
                ]),
                _c(
                  "span",
                  {
                    staticStyle: { "margin-left": "50px", "font-size": "15px" }
                  },
                  [_vm._v(_vm._s(_vm.filingStateLabel))]
                )
              ]),
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: !_vm.isEdit,
                    inline: true,
                    "label-width": "80px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_FilingBatchNo") }
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "20" },
                        model: {
                          value: _vm.form.filingBatchNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "filingBatchNo", $$v)
                          },
                          expression: "form.filingBatchNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_FilingDate") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customsDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.filingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "filingDate", $$v)
                          },
                          expression: "form.filingDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_EffectiveDate") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customsDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.effectiveDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "effectiveDate", $$v)
                          },
                          expression: "form.effectiveDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "280px" },
                        attrs: { maxlength: "500" },
                        model: {
                          value: _vm.form.filingRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "filingRemark", $$v)
                          },
                          expression: "form.filingRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section",
              staticStyle: { width: "100%", height: "100%" }
            },
            [
              _c(
                "div",
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OpenPriceInfo")))
                  ]),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        },
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_OpenPrice_edit"],
                          expression: "['button_OpenPrice_edit']"
                        }
                      ],
                      staticStyle: { "margin-left": "50px" },
                      attrs: { type: "primary", no: "addPrice" },
                      on: { click: _vm.toAddPrice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        },
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_OpenPrice_edit"],
                          expression: "['button_OpenPrice_edit']"
                        }
                      ],
                      attrs: { type: "danger", no: "deletePrice" },
                      on: { click: _vm.toDeletePrice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        },
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_OpenPrice_edit"],
                          expression: "['button_OpenPrice_edit']"
                        }
                      ],
                      attrs: { type: "primary", no: "past6MonthPort" },
                      on: { click: _vm.toQueryPast6MonthsPort }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Past6MonthPort")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        },
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_OpenPrice_edit"],
                          expression: "['button_OpenPrice_edit']"
                        }
                      ],
                      attrs: { type: "primary", no: "past1MonthPrice" },
                      on: { click: _vm.toQueryPast1MonthsPrice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Past1MonthPrice")))]
                  ),
                  _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "5px",
                        "margin-right": "5px"
                      },
                      attrs: {
                        no: "uploadPrice",
                        action: _vm.URL.price.openPrice.uploadOpenPrice,
                        headers: { sessionId: _vm.sessionId },
                        "show-file-list": false,
                        accept: ".xls,.xlsx",
                        "before-upload": _vm.beforeUpload,
                        "on-success": _vm.uploadExcelSuccess,
                        "on-error": _vm.uploadExcelError,
                        data: { params: _vm.uploadParam },
                        "on-progress": _vm.uploadProcess
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            },
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_OpenPrice_edit"],
                              expression: "['button_OpenPrice_edit']"
                            }
                          ],
                          attrs: { type: "primary", no: "upload" }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Upload")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        },
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_OpenPrice_edit"],
                          expression: "['button_OpenPrice_edit']"
                        }
                      ],
                      attrs: { type: "primary", no: "downImportTemplate" },
                      on: { click: _vm.downloadTemplate }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_DownImportTemplate"))
                      )
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "20px",
                        "font-size": "14px",
                        color: "red"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_DeclareNumLabel", [
                            _vm.declareNumLabel
                          ])
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "grid-wrapper",
                  staticStyle: { "padding-bottom": "30px", height: "100%" }
                },
                [
                  _c("cargo-ag-grid", {
                    ref: "tabPriceGrid",
                    staticStyle: { "padding-bottom": "50px", height: "100%" },
                    attrs: {
                      "grid-options": _vm.tabPrice.grid.gridOptions,
                      "column-defs": _vm.dynamicColumnDefs,
                      "grid-params": _vm.tabPrice.grid.gridParams,
                      "row-data": _vm.tabPrice.grid.rowData,
                      "show-side-bar": false,
                      "auto-fit-content": false
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(_vm.tabPrice.grid, "gridParams", $event)
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(_vm.tabPrice.grid, "gridParams", $event)
                      },
                      rowDataChanged: _vm.rowDataChanged,
                      gridReady: _vm.onCostGridReady
                    }
                  })
                ],
                1
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }